import { Service } from "../shared/Service";

export class PerfilUsuarioService extends Service {

    constructor() {
        super('v1/perfilUsuario');
    }
}